import React from "react";

function ConsumerMarketPanel({
  id,
  title,
  description,
  image,
  bodyType,
  expanded,
  onToggle,
  children,
}) {
  const className = [
    "global-consumer-panel",
    "global-consumer-teaser-panel",
    `global-consumer-panel--${id}`,
  ].join(" ");

  return (
    <section
      id={id}
      className={className}
      data-expanded={expanded ? "true" : "false"}
      style={expanded ? undefined : { backgroundImage: `url(${image})` }}
    >
      <div className="global-consumer-teaser-content">
        <div className="global-consumer-panel-header">
          <div className="global-consumer-teaser-copy">
            <h2>{title}</h2>
            <span aria-hidden="true" />
            <p>{description}</p>
          </div>
          <button
            type="button"
            className="global-consumer-panel-toggle"
            aria-label={`Toggle ${title}`}
            aria-expanded={expanded}
            onClick={() => onToggle(id)}
          />
        </div>
        <div
          className={`global-consumer-panel-body global-consumer-panel-body--${bodyType}`}
          aria-hidden={!expanded}
        >
          {children}
        </div>
      </div>
    </section>
  );
}

export default ConsumerMarketPanel;
